<div
  data-at-box
  class="vi-box flex flex-row gap-[{{ getGap() }}] justify-start items-start flex-1"
  [class.box-control]="isBoxControl"
  [class.dark-mode]="isDarkMode"
>
  <ng-content select="[icon]"></ng-content>
  <ng-content select="[item]"></ng-content>
  <ng-content select="[icon-2]"></ng-content>
  <ng-content select="[item-2]"></ng-content>
</div>
